<template>
  <div>
    <vs-input
      name="phone"
      class="w-full"
      :disabled="loggingIn"
      placeholder="09XXXXXXXXX"
      v-model="phone"
      @keyup.enter="login"
      maxlength="11"
    />

    <vs-button class="mt-6 w-full" :disabled="loggingIn" @click="login"
      >درخواست ارسال کد</vs-button
    >
  </div>
</template>

<script>
import authApiService from "@/services/api/AuthApiService";

export default {
  data() {
    return {
      phone: "",
      loggingIn: false,
    };
  },
  methods: {
    login() {
      this.loggingIn = true;
      this.$vs.loading();

      authApiService
        .login(this.phone)
        .then(() => {
          this.$emit("send-phone", this.phone);
        })
        .catch((err) => {
          let message = err.getErrorDescriptions();

          switch (err.status) {
            case 403:
              message = "شما اجازه دسترسی به این پنل را ندارید";
              break;
            case 404:
              message =
                err.error.response.data.message || "شماره همراه معتبر نیست";
              break;
          }

          this.$vs.notify({
            text: message,
            color: "danger",
            position: "bottom-center",
          });

          if (err.status === 403) {
            this.phone = "";
          }
        })
        .finally(() => {
          this.loggingIn = false;
          this.$vs.loading.close();
        });
    },
  },
};
</script>
